import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select"
import { useSelector } from 'react-redux';
import { selectLanguage } from '@/api/rtk/userSelectors'
import { useSetUserLanguageMutation } from '@/api/rtk/mutationsApi'
import { toast } from 'react-toastify';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const language = useSelector(selectLanguage);
  const [setUserLanguage, { isLoading: loading }] = useSetUserLanguageMutation();

  const handleLanguageChange = async (newLanguage) => {
    if (loading || !newLanguage || newLanguage === language) return;
    if (!localStorage.getItem('user_id')) return;
    try {
      await setUserLanguage({ language: newLanguage }).unwrap();
      i18n.changeLanguage(newLanguage);
    } catch (error) {
      if (!localStorage.getItem('user_id')) return;
      console.error("Failed to update language:", error);
      toast.error('Failed to set language. Please try again.');
    }
  };

  return (
    <Select
      value={language}
      onValueChange={handleLanguageChange}
      disabled={loading}
    >
      <SelectTrigger className="">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="es">Español</SelectItem>
        <SelectItem value="de">Deutsch</SelectItem>
        <SelectItem value="fr">Français</SelectItem>
        <SelectItem value="it">Italiano</SelectItem>
      </SelectContent>
    </Select>
  );
}

export default LanguageSwitcher;
